import PropTypes from "prop-types"
import { Navigate, useLocation } from "react-router-dom"
import ClientSalonGate from "./ClientSalonGate"
import localStorageService from "../../services/localStorage.service"

const ClientProtectedRoute = ({ children }) => {
  const location = useLocation()

  if (!localStorageService.isClientSessionValid()) {
    return <Navigate to="/client/login" replace state={{ from: location }} />
  }

  return <ClientSalonGate>{children}</ClientSalonGate>
}

ClientProtectedRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default ClientProtectedRoute
